import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { EnhancedJobForm } from '@/components/jobs/EnhancedJobForm';
import { useJob } from '@/hooks/useJobs';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Job } from '@/lib/types/job';

export default function EditJobPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') as 'basics' | 'specifications' | 'delivery' | null;
  const { job, loading, error, refetch } = useJob(jobId!);

  const handleJobSave = async (updatedJob: Job) => {
    // Refetch job data to ensure UI shows current state
    await refetch();
  };

  // Redirect if job is in a finalized state
  if (job && ['accepted', 'rejected', 'closed'].includes(job.status)) {
    navigate(`/jobs/${job.public_id}`);
    return null;
  }

  if (loading) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-center py-8">Loading job details...</div>
      </div>
    );
  }

  if (error || !job) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-center text-red-600 py-8">
          {error || 'Job not found'}
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 sm:p-6 max-w-4xl">
      <div className="mb-6">
        <Link 
          to={`/jobs/${job.public_id}`} 
          className="inline-flex items-center text-muted-foreground hover:text-foreground mb-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Job Details
        </Link>
        <h1 className="text-2xl sm:text-3xl font-bold">Edit Job</h1>
        <p className="text-sm sm:text-base text-muted-foreground">Job ID: {job.public_id}</p>
      </div>

      <EnhancedJobForm existingJob={job} onSave={handleJobSave} initialTab={initialTab || undefined} />
    </div>
  );
}